module.exports = __webpack_public_path__ + "img/40.a5d428c0.jpg";